import {chevronUpSvg as Icon__small__chevronUpSvg} from '../Icon__small/Icon__small--chevronUp.js';
import {chevronUpSvg as Icon__xsmall__chevronUpSvg} from '../Icon__xsmall/Icon__xsmall--chevronUp.js';
import {chevronUpSvg as Icon__xxsmall__chevronUpSvg} from '../Icon__xxsmall/Icon__xxsmall--chevronUp.js';

export var chevronUp = {
  name: 'chevronUp',
  category: 'icon',
  colorable: true,
  svg: Icon__small__chevronUpSvg,
  alt: {
    Icon__small: Icon__small__chevronUpSvg,
    Icon__xsmall: Icon__xsmall__chevronUpSvg,
    Icon__xxsmall: Icon__xxsmall__chevronUpSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall', 'Icon__xxsmall'],
};
